"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResultsContainer = exports.SearchCount = exports.ClearButton = exports.Container = void 0;
var React = __importStar(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var globalVars_module_scss_1 = __importDefault(require("../../globalVars.module.scss"));
var Button_1 = require("../Common/Button");
var smallSize = (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tright: ", ";\n"], ["\n\tright: ", ";\n"])), globalVars_module_scss_1.default.heightSmall);
var mediumSize = (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\tright: ", ";\n"], ["\n\tright: ", ";\n"])), globalVars_module_scss_1.default.heightMedium);
var largeSize = (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n\tright: ", ";\n"], ["\n\tright: ", ";\n"])), globalVars_module_scss_1.default.heightLarge);
exports.Container = styled_components_1.default.div.attrs({
    className: 'tws-searchbox-result-container',
})(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n\tposition: absolute;\n\t", ";\n\tbottom: ", ";\n\ttop: ", ";\n\tbackground: transparent;\n\tmargin: ", ";\n\tdisplay: ", ";\n\talign-items: ", ";\n"], ["\n\tposition: absolute;\n\t", ";\n\tbottom: ", ";\n\ttop: ", ";\n\tbackground: transparent;\n\tmargin: ", ";\n\tdisplay: ", ";\n\talign-items: ", ";\n"])), function (props) { return (props.inputSize === 'sm' ? smallSize : props.inputSize === 'lg' ? largeSize : mediumSize); }, globalVars_module_scss_1.default.spacing0, globalVars_module_scss_1.default.spacing0, globalVars_module_scss_1.default.spacing5, globalVars_module_scss_1.default.displayFlex, globalVars_module_scss_1.default.alignCenter);
exports.ClearButton = (0, styled_components_1.default)(Button_1.Button).attrs({
    className: 'tws-searchbox-clear-button',
})(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n\t&.btn.btn-sm {\n\t\tpadding: ", ";\n\t\theight: 16px;\n\t\twidth: 16px;\n\t\tfont-size: 10px !important;\n\t\tfont-weight: ", ";\n\t\tline-height: 16px;\n\t\tmin-height: inherit;\n\t\tdisplay: flex;\n\t\tjustify-content: center;\n\t\talign-items: center;\n\t}\n"], ["\n\t&.btn.btn-sm {\n\t\tpadding: ", ";\n\t\theight: 16px;\n\t\twidth: 16px;\n\t\tfont-size: 10px !important;\n\t\tfont-weight: ", ";\n\t\tline-height: 16px;\n\t\tmin-height: inherit;\n\t\tdisplay: flex;\n\t\tjustify-content: center;\n\t\talign-items: center;\n\t}\n"])), globalVars_module_scss_1.default.spacing0, globalVars_module_scss_1.default.fontWeightBold);
exports.ClearButton.displayName = 'ClearButton';
exports.SearchCount = styled_components_1.default.span.attrs({
    className: 'tws-searchbox-result-count',
})(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n\tmargin: ", ";\n\tfont-weight: ", ";\n\tcolor: ", ";\n"], ["\n\tmargin: ", ";\n\tfont-weight: ", ";\n\tcolor: ", ";\n"])), globalVars_module_scss_1.default.spacing5, globalVars_module_scss_1.default.fontWeightLight, globalVars_module_scss_1.default.secondaryGray2);
exports.SearchCount.displayName = 'SearchCount';
var ResultsContainer = /** @class */ (function (_super) {
    __extends(ResultsContainer, _super);
    function ResultsContainer(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            clearButtonSize: _this.props.clearButtonSize || 'sm',
            clearButtonColor: _this.props.clearButtonColor || 'secondary',
        };
        _this.handleOnClear = _this.handleOnClear.bind(_this);
        return _this;
    }
    ResultsContainer.prototype.render = function () {
        return (this.props.show && (React.createElement(exports.Container, { className: this.props.className, inputSize: this.props.inputSize },
            this.props.resultsCount !== undefined && React.createElement(exports.SearchCount, null,
                "(",
                this.props.resultsCount,
                ")"),
            React.createElement(exports.ClearButton, { size: this.state.clearButtonSize, color: this.state.clearButtonColor, onClick: this.handleOnClear }, "X"))));
    };
    ResultsContainer.prototype.handleOnClear = function () {
        this.props.onClear();
    };
    return ResultsContainer;
}(React.Component));
exports.ResultsContainer = ResultsContainer;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;
